var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.id != 'default')?_c('content-list-data',{key:_vm.id,attrs:{"list":_vm.id,"search":_vm.data_search,"enable-pin":"","include-path":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }